<template>
  <div class="main-content-container container-fluid px-4">
  	<div>
  		<div class="page-header row no-gutters py-4">
  			<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
  			  <span class="text-uppercase page-subtitle">Edición</span>
  			  <h3 class="page-title text-uppercase">{{ this.$route.params.name }}</h3>
  		  </div>
  	  </div>
   		<div class="row">
        <div class="col-lg-9 col-md-12">
          <div class="card card-small mb-3">
            <form type="POST" enctype="multipart/form-data">
            <div class="card-body">
                <div class="form-group">
                	<input type="text" class="form-control" :class="error.name.status" placeholder="Nombre" v-model="form.name">
                  <div class="invalid-feedback">
                    {{ error.name.message[0] }}
                  </div>
                </div>
                <div class="form-group">
                	<input type="text" class="form-control" v-model="slug" readonly>
                </div>
                <div class="form-group">
                  <drag-and-drop
                    message="Presiona o arrastra y suelta un archivo"
                    @file="setFile"
                    @base64="setBase64"
                  />
                </div>
                  <div class="alert alert-danger" v-if="error.icon.message !== ''">
                    <strong class="text-white">{{ error.icon.message[0] }}</strong>
                  </div>
                <div class="form-group">
                	<textarea rows="4" class="form-control" placeholder="Descripción" v-model="form.description"></textarea>
                </div>
            </div>
            <div class="card-footer border-top">
            	<button type="submit" class="btn btn-primary" @click.prevent="updateSolution()">
            		Actualizar
            	</button>
            </div>
            </form>
          </div>
        </div>
        <div class="d-none d-lg-inline-block col-lg-3 col-md-12">
          <div class='card card-small mb-3'>
            <div class="card-header border-bottom">
              <h6 class="m-0">Vista previa</h6>
            </div>
            <div class='card-body p-2 d-flex justify-content-center'>
  						<img :src="image.src" v-if="this.form.icon == '' || this.form.icon == undefined"/>
              <img :src="icon.src" v-if="this.form.icon"/>
            </div>
            <div class="card-footer">
            	<button class="btn btn-secondary" v-if="form.icon" @click.prevent="deleteIcon()">
                <i class="fas fa-trash"></i> 
              </button>
            </div>
          </div>
        </div>
      </div>
  	</div>
  </div>
</template>

<script>
  import DragAndDrop from '@/components/general/DragAndDrop.vue'
	import axios from 'axios'
	export default {
    components: {
      'drag-and-drop': DragAndDrop
    },

		data() {
			return {
				solution: [],
				form: {
					name: '',
					description: '',
					icon: ''
				},
        image: {
          src: ''
        },
        icon: {
          src: '',
          width: '',
          height: ''
        },
        error: {
          name: {
            status: '',
            message: ''
          },
          icon: {
            status: '',
            message: ''
          },
          description: {
            status: '',
            message: ''
          }
        }
			}
		},

    computed: {
      slug: function() {
        return this.form.name.toLowerCase().split(' ').join('_')
      }
    },

		mounted() {
			this.getSolution();
		},

		methods: {
			getSolution() {
				axios.get(`${process.env.VUE_APP_ROOT_API}/solution/${this.$route.params.name}`)
					.then(response => {
						this.solution = response.data;
            this.form.name = this.solution.name;
            this.form.description = this.solution.description;
            this.image.src = this.solution.icon;
					})
					.catch(err => {
						console.log(err);
					})
			},

      setFile(data) {
        this.form.icon = data;
      },

      setBase64(data) {
        this.icon.src = data;
      },

      deleteIcon() {
        this.form.icon = '';
        this.icon.src = '';
      },

      updateSolution() {
        if(this.form.icon) {
          this.updateAll();
        }else {
          this.updatePartially();
        }
      },

      updatePartially() {
        axios.put(`${process.env.VUE_APP_ROOT_API}/solution/partially/${this.solution.id}`, {
            user_id: this.$store.state.auth.user.id,
            name: this.form.name,
            description: this.form.description
          })
          .then(response => {
            this.successResponse();
          })
          .catch(err => {
            let errors = err.response.data.errors;
            switch (err.response.status) {
              case 200:
                this.successResponse();
                break;
              case 422:
                if(errors.name) {
                  this.error.name.status = 'is-invalid';
                  this.error.name.message = errors.name;
                }
                if(errors.icon) {
                  this.error.icon.status = 'is-invalid';
                  this.error.icon.message = errors.icon;
                }
                break;
            }
          });
      },

      updateAll() {
        let formData = new FormData();
        formData.append('user_id', this.$store.state.auth.user.id);
        formData.append('name', this.form.name);
        formData.append('slug', this.slug);
        formData.append('description', this.form.description);

        axios.post(`${process.env.VUE_APP_ROOT_API}/solution`, formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.successResponse();
          })
          .catch(err => {
            let errors = err.response.data.errors;
            switch (err.response.status) {
              case 422:
                if(errors.name) {
                  this.error.name.status = 'is-invalid';
                  this.error.name.message = errors.name;
                }
                if(errors.icon) {
                  this.error.icon.status = 'is-invalid';
                  this.error.icon.message = errors.icon;
                }
                if(errors.icon) {
                  this.error.description.status = 'is-invalid';
                  this.error.description.message = errors.description;
                }
                break;
            }
          });
      },

      successResponse() {
        this.$toasted.show("<i class='fas fa-circle'></i> ¡Solución actualizada!", { 
          theme: "toasted-primary", 
          position: "top-right", 
          duration : 2000
        });
        this.$router.replace('/soluciones');
        window.scrollTo(0, 0);
      },

      cleanErrorMessages() {
        this.error.name.status = '';
        this.error.name.message = '';

        this.error.description.status = '';
        this.error.description.message = '';

        this.error.icon.status = '';
        this.error.icon.message = '';
      }

		}
	}
</script>